import React, { useState, useEffect, useRef,useContext } from 'react';
import DynamicIcon from '../../components/dynamicicon';
import { Link, useNavigate,useParams  } from 'react-router-dom';
import * as Constants from '../../constants';
import { ShareContext } from '../../context/ShareContext';
import BackLoader from '../../components/backloader';
import JisButton from '../../components/controls/jisButton';
import CaseSearch from '../../components/core/case_search';
import JisEmptyList from '../../components/controls/emptylist';
import Pagenated from '../../components/pagenated';
import CaseDetails from '../../components/core/caseDetails';
import JisDialog from '../../components/dialog';
import JisYesNo from '../../components/controls/jisYesNo';
import JisCheckbox from '../../components/controls/jisCheckbox';
import JisDialogForm from '../../components/formdialog';
import JisTabButton from '../../components/controls/jisTabButton';
import DeadlineBadge from '../../components/controls/deadlinebadge';

function DeputySheriff() {
     const navigate = useNavigate();
    const {  activePage, token, profile,frequentData,setIsExpired, setAlert} = useContext(ShareContext);
    const [cases, setCases] = useState([]);
    const [loading, setLoading] =useState(false);
    const [pageIndex, setPageIndex]=useState(0);
    const [pageSize,setPageSize] = useState(Constants.PAGESIZE);
    const [isSearch, setIsSearch] =useState(false);
    const [search, setSearch]=useState(null);
    const [err,setErr]=useState('');
     const [isPreview, setIsPreview] = useState(false);
     const [count,setCount] = useState(0);
    const [active, setActive] =useState(null);
    const [index, setIndex] = useState(-1);
    const [openCase,setOpenCase] =useState(false);
    const [isLiti, setIsLitiation]=useState(null);
    const [openOption, setOpenOption] = useState(false);
    const [comment, setComment] =useState('');
    const [option, setOption]=useState({});
    const [suitNumber, setSuitnumber]=useState('');
    const [selected, setSelected] = useState(new Set()); //to hold the selected 
    const [selectedCases, setSelectedCases] = useState({});
    const [assignTo,setAssignTo]=useState(null);
    const [sheriffs, setSheriffs]= useState([]);
    const [tab, setTab] = useState('pending');
    const [lgid, setLgId] = useState(0);
    const [lgs,setLgs] = useState([]);

      useEffect(() => {
          //onLoad();
          onLoadSheriffByDivision();      
    }, []);

    useEffect(() => {
              
      if(search!=null){
        if(pageIndex>=0){
          console.log('loding from direct useEffect with pageIndex,pageSize,search');
              console.log(`is search ${isSearch}`)
            onSearch(search);
          }else{
            setPageIndex(0);
          }
      }
        if(lgs.length==0){
          onGetLgs();
        }
                 
   }, [pageIndex,pageSize,search, tab]);

    const claimTypes=[{id:1,title:'Mortgage'},{id:2,title:'Liquidated Damage'},
        {id:3,title:'Foreigner Involved'},{id:4,title:'Non Capital Offense'},
        {id:5,title:'Non Capital Offense'},
        {id:6, title:'Other'},{id:7,title:'None'}
    ]
const onCheck=(value,opt)=>{
        let sel=selected;
        let updateSel={...selectedCases};
        if(value){
        sel.add(opt.caseId)
        updateSel[opt.caseId]=opt;
        }else{
         sel.delete(opt.caseId);
          delete updateSel[opt.caseId];
        }
        setSelected(new Set(sel));
        setSelectedCases(updateSel)
        console.log(Object.keys(updateSel))
    }

    const onLoadSheriffByDivision= async()=>{
                //for account registration
            try {
    
                setLoading(true);
                const resp = await fetch(`${Constants.apiUrl}/profile/get-Service-Sheriff`, { 
                    method: 'GET',  headers: {  'Content-Type': 'application/json','Authorization': `Bearer ${token}`,}, });  
                const data = await resp.json();
                setLoading(false);
                if(data.code==0){
                  setSheriffs(data.pros)
                } else if(data.code==-10){
                          setIsExpired(true);
                      }
                
                } catch (error) {
                setLoading(false);
                console.error(error);   
                }
            }

  const onSearch=async(sear)=>{ 
            setSearch(sear)       ;
            setLoading(true)
            try {
            
            const resp = await fetch(`${Constants.apiUrl}/filing/service-sheriff/${lgid}/${tab}/${pageIndex}/${pageSize}`, {
                method: 'POST',
                body:JSON.stringify(sear) ,
                headers: {
                'Content-Type': 'application/json, text/plain',
                Authorization: `Bearer ${token}`,
                },
            });
            
            const data = await resp.json();
            setLoading(false);
            setIsSearch(true);
            if(data.code==0){
            //update the field
               setCases(data.items)
                if(pageIndex==0){
                setCount(data.totalCount)
               }
            }
             else if(data.code==-10){
                      setIsExpired(true);
                  }
                  else{
            //there is an error
            setErr(data.status);
            }
            
            } catch (error) {
            setLoading(false);
            console.error(error);
            setErr(Constants.serverErr);
            // onMove();
            }
        }

const onGetLgs= async()=>{
    //for account registration
    try {
        //setLocs({...locs,lga:false});
        const resp = await fetch(`${Constants.apiUrl}/profile/lgs/15`, { 
          method: 'GET',  headers: {  'Content-Type': 'application/json','Authorization': '',}, });  
        const data = await resp.json();
       setLgs(data);
 
       
      } catch (error) {

        console.error(error);   
      }
}
 
      const onPagePick=(pick)=>{
    console.log('this is selection value');
    setPageIndex(pick.id-1)
    console.log(pick)
}

    const onContinue=(fee,ind)=>{
        //navigate(`/case-details/${caseid}`)
        setActive(fee);
        setIndex(ind);
        setOpenCase(true);
    }

    const onCloseOpenCase=()=>{
    setActive(null);
    setIndex(-1);
    setOpenCase(false);
    }


const onSave=async(e)=>{
             e.preventDefault();
            

             if(assignTo==null){
               setErr('Please selecte one of the listed Service Sherrif');
               return;
             }
             
             var caseids=Array.from(selected);
             setErr('');
             //var judgeAs=isCmc==true?'CMC':'Trial';
              var approve={...option,caseids:caseids,assignType:'service-sheriff',assignTo:assignTo};
                
            setLoading(true)
            try {
            
                const resp = await fetch(`${Constants.apiUrl}/filing/Assign-Cases`, {
                method: 'POST',
                body:JSON.stringify(approve) ,
                headers: {
                'Content-Type': 'application/json, text/plain',
                Authorization: `Bearer ${token}`,
                },
            });
            
            const data = await resp.json();
            setLoading(false);
            console.log(data);
            if(data.code==0){
            //update the field
                setOpenOption(false)
               setSelected(new Set())
               setSelectedCases({});
                setAlert({open:true, title:'Deputy Sheriff Assignment', subtitle:'Cases assigned successfully'});
                setPageIndex(-1); // this will auto load again
                
            } else if(data.code==-10){
                setIsExpired(true);
            }else{
            //there is an error
            setErr(data.status);
            }
            
            } catch (error) {
            setLoading(false);
            console.error(error);
            setErr(Constants.serverErr);
            // onMove();
            }
       } 
     
const onOptionChange = (e) => {
    setOption({...option, [e.target.name]: e.target.value})
}



  return (
    <div>
     
      <CaseSearch onSearch={onSearch} frequentData={frequentData} />

      <div style={{textAlign:'right'}}>
        {Object.keys(selectedCases).length>0 && <JisButton onClick={()=> setOpenOption(true)}> Bulk Asign ({Object.keys(selectedCases).length})</JisButton>}  
      </div>

      <div className='tab_body'>
<div className='tab_section'>
            <JisTabButton isActive={tab=='pending'}  
       title="Pending" 
       isRoleBased={false} onClick={()=> setTab('pending')}/>
       <JisTabButton isActive={tab=='assigned'}  title="Assigned" 
       isRoleBased={false} onClick={()=> setTab('assigned')}/>
       <JisTabButton isActive={tab=='substituted'}  title="Substituted Cases" 
       isRoleBased={false} onClick={()=> setTab('substituted')}/>
       
        </div>
        <div className='tab_view'>
            {cases?.length==0 && <JisEmptyList/>}
            {cases?.length>0 && 
            <div className='table'>
              <div class="section-cases">
              <span>Deputy Sherrif </span><span className='total'>{count}</span>
            </div>
                  <table class="case-table">
              <thead>
                <tr>
                  <th>Suit Number</th>
                  <th>Case Title</th>
                  <th>Filing Type</th>
                  <th>Classification</th>
                  <th>Date Filed</th>
                  <th>Status Level</th>
                  <th>LGA</th>
                  <th>Address</th>
                  <td>SLA</td>
                  <th>Details</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {cases?.map((opt, index) => {
                  const cc=Constants.getSlaTimeLeft(opt.slaExpire);
                 return (
                  <tr key={index}>
                  <td style={{backgroundColor:`${Constants.getItemById(frequentData?.casecategories,opt.caseCategoryId)?.colour}`}}>{opt.caseNumber}</td>
                  <td>{opt.caseTitle}</td>
                  <td>{Constants.getItemById(frequentData?.casetype,opt.caseTypeId)?.caseType1}</td>
                  <td> {Constants.getItemById(frequentData?.casecategories,opt.caseCategoryId)?.categoryTitle}</td>
                  <td> {Constants.momentDate(opt.createdOn).format('DD MMM, YYYY')}</td>
                  <td>{Constants.getItemById(frequentData?.casestatuses,opt.caseStatusId)?.description}</td>
                  <td>{Constants.getItemById(lgs,opt.party?.lga)?.title}</td>
                  <td>{opt.party?.address1}</td>
                 <td> <DeadlineBadge dateString={opt.slaExpire} /> </td>
                  <td><JisButton variant='plain' onClick={()=>onContinue(opt,index)}>View</JisButton></td>
                  <td><JisCheckbox onChange={(e)=>onCheck(e,opt)} value={selected.has(opt.caseId)} /></td>
                </tr>
                )})} 
              </tbody>
            </table>
            {cases?.length>0 && <Pagenated onChangePageSize={(k)=>setPageSize(k)} size={pageSize} total={count} maxPage={20}  onPick={onPagePick}/>}    
            </div>}
        </div>
      </div>

<BackLoader open={loading} />

  
  {openCase && active!=null && <JisDialogForm title="Case Info" onClose={onCloseOpenCase}>
      <div>
        <CaseDetails  caseId={active.caseId} data={null} token={token} initialtab="casedocuments" />
      </div>
      </JisDialogForm> }

      {openOption && <JisDialogForm title=" Case Assignment"  onClose={()=>setOpenOption(false)}>
                          <form onSubmit={onSave}>
                            <div style={{display:'flex'}}>
                               <div style={{flex:3}}>
                                 
                                    <div>
                                          
                                          <div className="select-group">
                                              <label>
                                                  Service Sheriff:  
                                              </label>
                                              <div className='content-box' style={{maxHeight:300}}>
                                                 {sheriffs?.map((opt) => (
                                                  <div key={opt.id}  onClick={()=>setAssignTo(opt.id)} className={`selected ${opt.id==assignTo?'active':''}`}>
                                                      {opt.suffix} {opt.firstName} {opt.lastName}
                                                  </div>
                                                  ))}
                                                 {sheriffs?.length==0 && <JisEmptyList/>} 
                                              </div>
                                              
                                          </div>
                                          
      
                                    </div> 
                                  <div  className="input-group">
                                      <label>Comment <span className="required">*</span> </label>
                                      <div className='input-wrapper'>
                                          <DynamicIcon iname="group" />
                                          <textarea placeholder=' Comment' name='comment' required={true}  value={option.comment}
                                  onChange={onOptionChange }  />
                                      </div>
                                  </div> 
                                  {err!="" && <div className='error'>{err}</div>}
      
                               
                                  <JisButton type="submit">Save </JisButton>     <JisButton type="button" onClick={()=> setOpenOption(false)}>Cancel </JisButton>             
                              </div>
                              <div style={{flex:1,maxHeight:300}}  className='content-box'>
                                <div>
                                  Selected Cases to Assign ({Object.values(selectedCases).length})
                                </div>
                                {Object.values(selectedCases)?.map((opt,index) => (
                                                  <div className='selected' key={index} >
                                                    <div>{opt.caseNumber}</div> 
                                                    <p style={{fontSize:12}}>{opt.caseTitle}</p> 
                                                  </div>
                                                  ))}
                              </div>
                            </div>
                             
                          </form>
                  </JisDialogForm>}     
    </div>
  );
}

export default DeputySheriff;